import { contextFactory } from "../../../utils/contextFactory";
import type { FormFieldContextType } from "../FormField";

export const [FormFieldProvider, useFormFieldContext] =
  contextFactory<FormFieldContextType>({
    displayName: "FormFieldProvider",
    isOptional: true,
  });
